<template>
  <div>
    <top-small-nav></top-small-nav>
    <div class="nav">
      <img :src="logo"
           onerror="@/assets/images/ic_logo.png" />
    </div>
  </div>
</template>

<script>
import { configData } from '@/api/login'
import TopSmallNav from '@/views/layout/components/TopSmallNav'

export default {
  name: 'topNav',
  components: {
    TopSmallNav
  },
  data() {
    return {
      logo: require('@/assets/images/ic_logo.png')
    }
  },
  created() {
    configData({ key: 'L_backstageLogo', tips: '管理后台Logo' }).then(res => {
      if (res.data && res.data.name) {
        this.logo = res.data.name
      }
    })
  }
}
</script>

<style scoped>
.nav {
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 88px;
  background-color: white;
}

.nav img {
  height: 43px;
  margin-left: 104px;
}
</style>




// WEBPACK FOOTER //
// src/views/login/components/TopNav.vue